/**
 * Convert a byte count to a human-readable size string.
 * Uses MB for sizes ≥ 1 MB, KB otherwise. Always one decimal place for MB.
 */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null || bytes < 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
